<script>
    import ProgressBar from "progressbar.js";
    import { onMount } from "svelte";
    import { tresh1, tresh2, tresh3 } from "../scripts/questions";

    export let title = "";
    export let color = "green";
    export let value = 0;
    export let width = 150;
    export let chartType = "turn";

    let circleContainer;

    function handleValue(type = "normal") {
        if(type === "turn") { 
            value = 1 - value;

            if(value <= tresh1) color = "rgb(255, 51, 51)";
            else if(value > tresh1 && value < tresh2) color = "rgb(255, 170, 51)";
            else if(value >= tresh2 && value < tresh3) color = "rgb(255, 235, 0)";
            else if(value >= tresh3) color = "rgb(0, 204, 102)";
        }
        else {
            if(value <= tresh1) color = "rgb(0, 204, 102)";
            else if(value > tresh1 && value < tresh2) color = "rgb(255, 235, 0)";
            else if(value >= tresh2 && value < tresh3) color = "rgb(255, 170, 51)";
            else if(value >= tresh3) color = "rgb(255, 51, 51)";  
        }
    }

    handleValue(chartType);

    onMount(() => {
        const circle = new ProgressBar.Circle(circleContainer, {
            strokeWidth: 9,
            easing: 'easeInOut',
            duration: 500,
            color: color,
            trailColor: '#eee',
            trailWidth: 1,
            svgStyle: null,
        });

        circle.setText(Math.round(value * 100).toString());
        circle.animate(value);

        const barText = circleContainer.querySelector(".progressbar-text");
        barText.style.color = "#333";
        barText.style.fontWeight = "500";
        barText.style.fontSize = "30px";
    });
</script>

<style>
    .circle-cont {
        width: 150px; 
        margin: 0 auto; 
        cursor: pointer;        
    }
    @media screen and (max-width: 390px) {
        .circle-cont { width: 140px; }
    }
</style>

<div style="width: fit-content; margin-right: .5rem; margin-bottom: 1rem;">
    <h4 style="text-align:center; margin-bottom: 0.5rem !important;">{ title }</h4>
    <div bind:this={ circleContainer } class="circle-cont" on:click></div>
</div>
  